// How to create a recharts custom tooltip in typescript:
// https://stackoverflow.com/questions/65913461/typescript-interface-for-recharts-custom-tooltip
import { TooltipProps } from "recharts";

export type ValueType = number | string | Array<number | string>;
export type NameType = number | string;

const PowerBarChartTooltip = ({
  active,
  payload,
}: TooltipProps<ValueType, NameType>) => {
  if (active && payload && payload.length) {
    return (
      <div className="rounded-lg bg-zinc-900 p-4 font-medium text-white shadow-2xl">
        <p className="text-xs">
          {(payload[0] as { payload: { name: string } }).payload.name}
        </p>
      </div>
    );
  }
  return null;
};

export default PowerBarChartTooltip;
